import React from "react";
import bg from "../assets/images/bg-coming-soon.png";

const Matching = () => {
  return (
    <div className="w-full h-[100vh] flex justify-center items-center">
      <img src={bg} alt="comming soon" />
    </div>
  );
};

export default Matching;
